import React from 'react'

const ServiceButton = ({images,name}) => {
  return (
    <>
    <div className="mx-auto w-[160px] flex-col justify-between text-center px-2 py-4 " >
        <img src={images} alt="images" className="h-[100px] w-[100px] mx-auto shadow-xl rounded-full border-gray-400 border-2"/>
        <p className='text-lg font-roboto mx-auto pt-3 '>{name}</p>
    </div>
    </>
  )
}

export default ServiceButton